import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';
import sizeStandards from '../../../Style-guide/size-standards';

const SignInWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;

  .page-title {
    text-align: center;
  }

  .inputs-container {
    max-width: 500px;
    width: 100%;
    margin: 20px auto;
    display: flex;
    align-items: center;
    flex-direction: column;

    .field {
      max-width: 300px;
      width: 100%;
      margin: 12px 0;
    }

    .submit-btn {
      max-width: 120px;
      width: 100%;
      padding: 10px;
      margin: 30px 0;
    }
  }

  .register-redirection-text {
    text-align: center;
    margin-bottom: 7vh;

    @media only screen and (max-width: ${sizeStandards.screen.XL}px) {
      margin-bottom: 11vh;
    }

    @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
      margin-bottom: 14vh;
    }

    .link-to-sign-up {
      margin-left: 8px;
      text-decoration: none;
      color: ${mainColors.text_color};

      &:hover {
        color: ${mainColors.main_color};
      }
    }
  }
`;

export default SignInWrapper;
